import * as React from "react";
import { DataGrid, ruRU } from "@mui/x-data-grid";
import { useDispatch } from "react-redux";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useAppSelector } from "../../hooks";
import {
  clientsDataPage,
  clientsDataUpdate,
  clientsDataDelete,
} from "src/features/clients/clientsActions";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { useEffect } from "react";

export default function ClientsPaginationGrid() {
  const dispatch = useDispatch();

  const { dataClientsPage } = useAppSelector((state) => state.clientsPage);

  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 5,
  });

  const { pageInfo, setPageInfo } = {
    totalRowCount: dataClientsPage?.payload?.count,
  };

  // Some API clients return undefined while loading
  // Following lines are here to prevent `rowCountState` from being undefined during the loading
  const [rowCountState, setRowCountState] = React.useState(
    pageInfo?.totalRowCount || 0
  );
  React.useEffect(() => {
    setRowCountState((prevRowCountState) =>
      pageInfo?.totalRowCount !== undefined
        ? pageInfo?.totalRowCount
        : prevRowCountState
    );
  }, [pageInfo?.totalRowCount, setRowCountState]);

  useEffect(() => {
    dispatch(
      clientsDataPage([paginationModel.page, paginationModel.pageSize])
    ).then(() => {
      setRowCountState({ totalRowCount: dataClientsPage?.payload?.count });
    });
  }, [paginationModel.page, paginationModel.pageSize]);

  const columns = [
    { field: "id", headerName: "ID", width: 40 },
    {
      field: "title",
      headerName: "Название клиента",
      width: 400,
      editable: true,
    },
    {
      field: "action",
      headerName: "",
      width: 120,
      sortable: false,
      disableClickEventBubbling: true,

      renderCell: (params) => {
        const onClickRemove = (e) => {
          dispatch(clientsDataDelete(params.row)).then(() => {
            dispatch(clientsDataPage([1, 5]));
            setSnackbar({ children: "Данные удалены !", severity: "success" });
          });
        };

        return (
          <Stack direction="row" spacing={0}>
            <Button
              variant="outlined"
              color="error"
              size="small"
              onClick={onClickRemove}
              sx={{
                width: 100,
              }}
            >
              Удалить
            </Button>
          </Stack>
        );
      },
    },
  ];

  const [sortModel, setSortModel] = React.useState([
    {
      field: "id",
      sort: "asc",
    },
  ]);

  const [snackbar, setSnackbar] = React.useState(null);

  const handleProcessRowUpdateError = React.useCallback((error) => {
    setSnackbar({ children: error.message, severity: "error" });
  }, []);

  const processRowUpdate = React.useCallback(
    async (newRow) => {
      const response = await dispatch(clientsDataUpdate(newRow));

      setSnackbar({ children: "Данные обновлены !", severity: "success" });

      return response.payload; // return the new row containing the row id
    },
    [dispatch]
  );

  const handleCloseSnackbar = () => setSnackbar(null);

  return (
    <div style={{ height: 400, width: "100%" }}>
      <DataGrid
        localeText={ruRU.components.MuiDataGrid.defaultProps.localeText}
        rows={dataClientsPage?.payload?.list ?? []}
        rowCount={dataClientsPage?.payload?.count ?? 0}
        loading={dataClientsPage?.loading}
        columns={columns}
        pageSizeOptions={[5, 10]}
        paginationModel={paginationModel}
        paginationMode="server"
        onPaginationModelChange={setPaginationModel}
        processRowUpdate={processRowUpdate}
        onProcessRowUpdateError={handleProcessRowUpdateError}
        sortModel={sortModel}
      />

      {!!snackbar && (
        <Snackbar
          open
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          onClose={handleCloseSnackbar}
          autoHideDuration={1500}
        >
          <Alert {...snackbar} onClose={handleCloseSnackbar} />
        </Snackbar>
      )}
    </div>
  );
}
